import { Section } from '@/components/shared/Content';
import { Flex } from '@lemonade-hq/cdk';
import type { FC } from 'react';
import styled from 'styled-components';
import { GBSectionParagraph, GBSectionTitle } from './StyledElements';

const ContentWrapper = styled(Flex)`
  max-width: 760px;
`;

export interface WhatIsGivebackProps {
  title: string;
  p1: string;
  p2: string;
}

export const WhatIsGiveback: FC<WhatIsGivebackProps> = ({ title, p1, p2 }) => {
  return (
    <Section pt={[70, 40]} pb={[50, 96]} px={20} darkBackground>
      <GBSectionTitle tabIndex={0}>{title}</GBSectionTitle>
      <ContentWrapper flexDirection="column" alignItems="center" mt={20}>
        <GBSectionParagraph tabIndex={0}>{p1}</GBSectionParagraph>
      </ContentWrapper>
      <ContentWrapper flexDirection="column" alignItems="center" mt={20}>
        <GBSectionParagraph>{p2}</GBSectionParagraph>
      </ContentWrapper>
    </Section>
  );
};
